import React, { useState } from 'react';
import { DeleteFaqCategory } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { SupportController } from '../../controllers';

const DeleteFaqCategoryContainer = ({closeModal, data}) => {
    const [loading, setLoading] = useState(false);
    
    const handleDelete = async () => {
        setLoading(true);       
        const { status, errorMessage } = await SupportController.deleteFaqCategory(data._id); 
        if (status === constant.Success) {
            SupportController.getFaqs();           
            MimaToastUtil.success({ message: constant.Success })
           setLoading(false);
           return closeModal();
        }  else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }

    const goBack = () => {
        closeModal();
    }
    return (
        <DeleteFaqCategory
        loading={loading}
        handleDelete={handleDelete}
        closeModal={closeModal}
        goBack={goBack}
        data={data}
        />
    )
}
export default DeleteFaqCategoryContainer;